import { observable, action } from 'mobx';
import { plainToClassFromExist } from 'class-transformer';
import PostsService from '../../service/PostsService';
import QuestionService from '../../service/QuestionService';

// answerUnit

class VideoLiUnit {
    public accountId: number; // 回答量
    public avatar: string; // 头像
    public browseSum: number; // 浏览量
    public collectSum: number; // 收藏数
    public favourSum: number; // 点赞数
    public id: number; // id
    public title: string; // 标题：文章，专题,问题名称
    public releaseTime: number; // 内容发布时间
}

// request detail
class VideoList {
    @observable public results: VideoLiUnit[] = [];
    @observable public totalCount: number;
    @observable public pageNo: number = 1;
    @observable public pageSize: number = 10;
    @observable public dataStatus: string;
    @action public get(param) {
        this.dataStatus = 'pending';
        return PostsService.videoPosts(param)
            .then((res) => {
                this.dataStatus = 'done';
                // plainToClassFromExist(this, res);
                this.results = res.results;
                this.totalCount = res.totalCount;
                this.pageNo = res.pageNo;
                this.pageSize = res.pageSize;
                return res;
            })
            .catch((err) => {
                this.dataStatus = 'error';
            });
    }
    @action public del(id, fn) {
        return PostsService.delPosts(id).then((res) => {
            // plainToClassFromExist(this, res);
            fn && fn();
            return res;
        });
    }
}

class Img {
    @observable public url: string;
    @observable public imageRes: string;
}
class AddPics {
    @observable public content: string;
    @observable public images: Img[] = [];
    @observable public nickname: string;
    @observable public releaseTime: number;
    @observable public avatar: string;
    @observable public title: string;
    @observable public videoUrlHigh: string;
    @observable public videoUrlSource: string;
    @observable public imageUrls: any[] = [];
    @action public set(obj) {
        plainToClassFromExist(this, obj);
    }
    @action public set_v2_request(param) {
        // v2接口
        return QuestionService.publish_v2(param).then((res) => {
            return res;
        });
    }
    @action public edit_v2_request(param) {
        // v2接口
        return QuestionService.editorial_v2(param).then((res) => {
            return res;
        });
    }
    @action public get(id) {
        return QuestionService.getDetail(id).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

 // 我的动态 
class PicsList {
    @observable public results: VideoLiUnit[] = [];
    @observable public totalCount: number;
    @observable public pageNo: number = 1;
    @observable public pageSize: number = 10;
    @observable public dataStatus: string;
    @action public get(param) {
        this.dataStatus = 'pending';
        return PostsService.picsPosts(param)
            .then((res) => {
                this.dataStatus = 'done';
                // plainToClassFromExist(this, res);
                this.results = res.results;
                this.totalCount = res.totalCount;
                this.pageNo = res.pageNo;
                this.pageSize = res.pageSize;
                return res;
            })
            .catch((err) => {
                this.dataStatus = 'error';
            });
    }
    @action public del(id, fn) {
        return PostsService.delPosts(id).then((res) => {
            // plainToClassFromExist(this, res);
            fn && fn();
            return res;
        });
    }
}
 // 图文混排列表
class EditPicsList {
    @observable public results: VideoLiUnit[] = [];
    @observable public totalCount: number;
    @observable public pageNo: number = 1;
    @observable public pageSize: number = 10;
    @observable public dataStatus: string;
    @action public get(param) {
        this.dataStatus = 'pending';
        return PostsService.editPicsList(param)
            .then((res) => {
                this.dataStatus = 'done';
                // plainToClassFromExist(this, res);
                this.results = res.results;
                this.totalCount = res.totalCount;
                this.pageNo = res.pageNo;
                this.pageSize = res.pageSize;
                return res;
            })
            .catch((err) => {
                this.dataStatus = 'error';
            });
    }
    @action public del(id, fn) {
        return PostsService.delPosts(id).then((res) => {
            // plainToClassFromExist(this, res);
            fn && fn();
            return res;
        });
    }
}

export { VideoList, AddPics, PicsList, EditPicsList };
